module.exports = __webpack_public_path__ + "static/media/angel-right-circle-thin.072b6ec6.svg";